module.exports = __webpack_public_path__ + "img/IMG_4531.8f38eb63.jpg";